export function isMeetingRequest(itemClass: string | undefined): boolean {
    return !!(itemClass && itemClass.match(/^ipm\.schedule\.meeting\.request/i));
}
